module.exports = __webpack_public_path__ + "static/img/blog-4.886303b6.jpg";